module.exports = __webpack_public_path__ + "img/guangGong2.884abade.png";